<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container-fluid">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										Note To Balance Sheet (Horizontal)
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :form="form" @filterAction="filterAction"
										:filter="filter"></report-filter>
									<b-button @click="printPDF" class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'print']" />
									</b-button>
									<b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'download']" />
									</b-button>
								</div>
							</div>
						</div>
						<div class="card-body" ref="pdfContent">
							<div class="row">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution" :current_date="false"
										:title="'NOTE TO THE BALANCE SHEET (HORIZONTAL)'"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list_display }}
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-12 text-end">
									<div>
										Terms:
										<span class="fw-bold">{{
											form.terms
										}}</span>
									</div>
									<span class="mt-2">From:
										<strong>{{ form.start_date }}</strong>
										To: <strong>{{ form.end_date }}</strong>
									</span>
								</div>
							</div>
							<div v-if="isBusy" class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
							</div>
							<div v-else id="balance-sheet" class="row">
								<div class="col-12 my-2"></div>
								<div class="col-12 col-md-12 px-0 trans_details">
									<b-table-simple bordered responsive outlined>
										<b-thead>
											<b-tr variant="secondary">
												<b-th class="text-center fs-6 akkurate-green"
													colspan="3"><span>ASSETS</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<!-- Loop through COA heads for receipts -->
											<template v-for="(head, index) in assets_items">
												<b-tr>
													<td  width="50%" class="py-0 px-2 fw-bold">
														{{ head?.display_name }}
													</td>
													<td class="py-0 px-2 fw-bold">
														{{ head.transactions[0]?.balance }}
													</td>
												</b-tr>
												<b-tr v-for="(subhead, idx) in head?.subheads"
													:key="idx + subhead?.name">
													<td  width="50%" class="py-0 px-2">
														{{ subhead.code }} - {{ subhead?.name }}
													</td>
													<td class="py-0 px-2">
														{{ institution?.currency_code }} {{
															displayNumber(subhead?.total) }}
													</td>
												</b-tr>

											</template>
										</b-tbody>
									</b-table-simple>
								</div>
								<div class="col-12 col-md-12 p-0 trans_details">
									<b-table-simple outlined bordered>
										<b-tfoot>
											<b-tr>
												<b-th width="30%" class="py-0 px-2">Total Assest</b-th>
												<b-th width="20%" class="py-0 px-2"></b-th>

												<b-th class="py-0 px-2" variant="success">{{ institution.currency_code
												}}
													{{ displayNumber(grant_total_assets) }}
												</b-th>
											</b-tr>
											<b-tr v-for="(provision, item) in provisions" :key="item + 'provision'"
												class="list-item">
												<b-td style="font-weight: bold">LESS {{
													provision.display_name
												}}</b-td>
												<b-td style="font-weight: bold"
													v-if="provision.transactions.length > 0">
													{{ institution.currency_code }}
													{{ displayNumber(provision.transactions[0]?.balance ?
														provision.transactions[0]?.balance : 0) }}
												</b-td>
												<b-td style="font-weight: bold" v-else>
													{{ institution.currency_code }}
													{{ displayNumber(0) }}
												</b-td>
												<b-td class="list-item">
													<div v-for="(val, idx) in provision.subheads"
														:key="idx + 'provision_subhead'" class="row">
														<div class="col-6">
															{{ val.name }}
														</div>
														<div class="col-6 fw-bold">
															{{ institution.currency_code }}
															{{ displayNumber(val.total ? val.total.toFixed(2) : 0) }}
														</div>
														<hr v-if="idx < provision.subheads.length - 1"
															style="border-color: #808080;" class="m-0 ms-1" />
													</div>
												</b-td>
											</b-tr>
											<b-tr>
												<b-th class="py-0 px-2">Net Asset</b-th>
												<b-th class="py-0 px-2"></b-th>
												<b-th class="py-0 px-2" variant="success">{{
													institution.currency_code
												}}
													{{
														displayNumber(net_assets)
													}}</b-th>
											</b-tr>
										</b-tfoot>
									</b-table-simple>
								</div>
								<div class="col-12 col-md-12 px-0 trans_details">
									<b-table-simple bordered responsive outlined>
										<b-thead>
											<b-tr variant="secondary">
												<b-th class="text-center fs-6 akkurate-green"
													colspan="3"><span>LIABILITIES + CAPITAL</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<!-- Loop through COA heads for receipts -->
											<template v-for="(head, index) in liability_items">
												<b-tr>
													<td width="50%" class="py-0 px-2 fw-bold">
														{{ head?.display_name }}
													</td>
													<td class="py-0 px-2 fw-bold">
														{{ institution.currency_code }} {{
															displayNumber(head.transactions[0]?.balance) ?? 0.00 }}
													</td>
												</b-tr>
												<b-tr v-for="(subhead, idx) in head?.subheads"
													:key="idx + subhead?.name">
													<td  width="50%" class="py-0 px-2">
														{{ subhead.code }} - {{ subhead?.name }}
													</td>
													<td class="py-0 px-2">
														{{ institution?.currency_code }} {{
															displayNumber(subhead?.total) }}
													</td>
												</b-tr>
											</template>
										</b-tbody>

									</b-table-simple>
								</div>
								<div class="col-12 col-md-12 p-0 trans_details mt-auto">
									<b-table-simple outlined>
										<b-tfoot>
											<b-tr>
												<b-th class="py-0 px-2" width="50%">Total Liability</b-th>
												<b-th class="py-0 px-2">{{
													institution.currency_code
												}}
													{{ displayNumber(this.grant_total_liabilities) }}</b-th>
											</b-tr>
											<b-tr>
												<b-th class="py-0 px-2" width="50%">Total Surplus</b-th>
												<b-th class="py-0 px-2">{{
													institution.currency_code
												}}
													{{ displayNumber(grant_total_surpluses) }}</b-th>
											</b-tr>
											<b-tr>
												<b-th class="py-0 px-2" width="50%">Total Liabilities +
													Surplus</b-th>
												<b-th class="py-0 px-2" variant="success">{{
													institution.currency_code
												}}
													{{
														displayNumber(liabilities_plus_surplus)
													}}</b-th>
											</b-tr>
										</b-tfoot>
									</b-table-simple>
								</div>
							</div>
							<div class="row">
								<div class="col-12 p-0 text-center akkurate-green mb-2 fw-bold">
									Information on Ratio
								</div>
								<div class="col-6 p-0">
									<b-table-simple outlined>
										<b-tfoot>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2">Liquidity Reserve</b-th>
												<b-th class="py-0 px-2">{{ liquidity_res }} %</b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2" width="50%">Return on Asset</b-th>
												<b-th class="py-0 px-2">{{
													return_on_assets
												}}
													%</b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2" width="50%">Capital Adequacy</b-th>
												<b-th class="py-0 px-2">{{
													capital_adequacy
												}}
													%</b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2" width="50%">Prepared By</b-th>
												<b-th class="py-0 px-2"></b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2" width="50%">Accountant</b-th>
												<b-th class="py-0 px-2"></b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2" width="50%">Signature</b-th>
												<b-th class="py-0 px-2"></b-th>
											</b-tr>
										</b-tfoot>
									</b-table-simple>
								</div>
								<div class="col-6 p-0">
									<b-table-simple responsive outlined>
										<b-tfoot>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2" colspan="2">(Total liquid Funds / total
													assets * 100)</b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2" colspan="2">(Surplus difference / total
													assets * 100)</b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2" colspan="2">([Member Shares + total
													capital res] / total assets
													* 100)</b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2">Certified By</b-th>
												<b-th class="py-0 px-2"></b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2">Manager/Board
													Treasurer</b-th>
												<b-th class="py-0 px-2"></b-th>
											</b-tr>
											<b-tr class="trans_details">
												<b-th class="py-0 px-2">Signature</b-th>
												<b-th class="py-0 px-2"></b-th>
											</b-tr>
										</b-tfoot>
									</b-table-simple>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "../form/ReportFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	data() {
		return {
			form: {
				start_date: this.getBeginningOfYear(),
				end_date: new Date().toISOString().split("T")[0],
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "YTD",
				terms_options: ["YTD", "Periodic"],
				categories: [],
				loan_status:[],
			},
			filter: {
				branches: true,
				products: false,
				users: false,
				status: false,
				condition: false,
				terms: true,
				coa: false,
				voucher_status: false,
				start_date: true,
				end_date: true,
				loan_status:false,
			},
			grant_total_provisions: 0,
			search: "Search",
			grant_total_liabilities: 0,
			liabilities_plus_surplus: 0,
			grant_total_surpluses: 0,
			grant_total_assets: 0,
			isBusy: false,
			isSearching: false,
			selected_num: "10",
			numbers_options: [10, 50, 100, 500],
			isLoadingInstitution: false,
			institution: "",
			start_date: "",
			end_date: "",
			liability_items: "",
			assets_items: "",
			provisions: [],
			loan_to_member: "",
			total_loans: 0,
			surpluses: "",
			// loan_losses: 0,
			accumulated_dep: 0,
			liquid_funds: 0,
			reserves: 0,
			net_assets: 0,
			branch_list: [],
			fields: [
				{
					key: "account_number",
					label: "Account Number",
				},
				{
					key: "customer_name",
					label: "Customer Name",
				},
				{
					key: "amount",
					label: "Amount",
				},
				{
					key: "min_balance",
					label: "Minimum Balance",
				},
				{
					key: "total",
					label: "Total",
				},
			],
			perPage: 20,
			currentPage: 1,
			items: [],
			total_assets: 0,
			member_shares: 0,
		};
	},
	computed: {
		rows() {
			return this.items.length;
		},
		sumLoanBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].loan_balance;
			}
			return total;
		},
		sumSavingBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].saving_balance;
			}

			return total;
		},
		liquidity_res() {
			return (
				Number(
					(this.liquid_funds / this.grant_total_assets) * 100
				).toFixed(2) ?? 0
			);
		},
		return_on_assets() {
			return (
				Number(
					(this.grant_total_surpluses / this.grant_total_assets) *
					100
				).toFixed(2) ?? 0
			);
		},
		capital_adequacy() {
			return (
				Number(
					((this.member_shares + this.reserves) /
						this.grant_total_assets) *
					100
				).toFixed(2) ?? 0
			);
		},
		totalProvisionYear() {
			return this.provisions
				.reduce(
					(total, item) => total + parseFloat(item.yearly_amount),
					0
				)
				.toFixed(2);
		},

		totalAssetsMinusProvision() {
			return this.total_loans - this.totalProvisionYear ?? 0;
		},
		branch_list_display() {
			const selected = this.form.branches || [];
			const all = this.form.branch_options || [];

			if (selected.length > 0) {
				return selected.map(b => b.name).join(", ");
			}
			if (all.length > 0) {
				return all.map(b => b?.name).join(", ");
			}
			return "";
		}
	},

	created() {
		this.getInstitution();
		this.getBalanceSheets();
		this.getProductDropdown();
	},
	methods: {
		async getProductDropdown() {
			this.isBusy = true;
			this.search = "Processing...";
			await ApiService.query("/reports/controls/products/dropdown")
				.then((response) => {
					this.isBusy = false;
					this.search = "Search";
					this.form.branch_options = response.data.branches;
				})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
				});
		},

		async getBalanceSheets() {
			this.items = [];
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;
			await ApiService.post("/reports/financials/balance-sheet", {
				startDate: this.form.start_date,
				endDate: this.form.end_date,
				terms: this.form.terms,
				branch: this.form.branches,
			})
				.then((response) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					var res = response.data;
					this.assets_items = res.assets;
					this.liability_items = res.liabilities;
					this.surpluses = res.surpluses;
					this.grant_total_assets = res.grant_total_assets;
					this.grant_total_liabilities = res.grant_total_liabilities;
					this.grant_total_surpluses = res.total_surpluses;
					this.liabilities_plus_surplus = this.grant_total_liabilities + this.grant_total_surpluses;
					this.start_date = this.form.start_date;
					this.end_date = this.form.end_date;
					this.provisions = res.provisions;
					this.loan_to_member = res.loan_to_member;
					this.accumulated_dep = res.accumulated_dep;
					this.liquid_funds = res.liquid_funds;
					this.reserves = res.reserves;
					this.member_shares = res.member_shares;
					this.grant_total_provisions = res.grant_total_provisions;
					this.net_assets = res.net_assets;
				})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					console.log(error);
				});
		},

		downloadPDF() {
			const content = this.$refs.pdfContent;
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2],
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},

		printPDF() {
			const content = this.$refs.pdfContent;
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2],
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },
				pagebreak: { mode: "slice" },
				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					var pdfUrl = URL.createObjectURL(pdfBlob);
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},

		filterTable() {
			this.getBalanceSheets();
		},

		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},

		filterAction() {
			this.getBalanceSheets();
		},

		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx";
			const imageUrl = "/default_logo.png";

			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;
			const date =
				"FROM: " +
				this.form.start_date +
				" TO: " +
				this.form.end_date;
			const terms = "TERMS:  " + this.form.terms;

			try {
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				const ws = wb.getWorksheet(1);

				// Add logo
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png",
				});

				ws.addImage(imageId, {
					tl: { col: 0, row: 0 },
					ext: { width: 300, height: 200 },
				});

				// Add institution details
				const institutionDetailsRow = 1;

				ws.getCell(`L${institutionDetailsRow}`).value =
					institutionName;
				ws.getCell(`L${institutionDetailsRow}`).font = {
					bold: true,
					size: 14,
				};

				ws.getCell(`L${institutionDetailsRow + 1}`).value =
					institutionAddress;
				ws.getCell(`L${institutionDetailsRow + 1}`).font = {
					size: 12,
				};

				ws.getCell(`L${institutionDetailsRow + 2}`).value =
					institutionMotto;
				ws.getCell(`L${institutionDetailsRow + 2}`).font = {
					size: 12,
				};

				ws.getCell(`L${institutionDetailsRow + 3}`).value =
					institutionPhone;
				ws.getCell(`L${institutionDetailsRow + 3}`).font = {
					size: 12,
				};

				ws.getCell(`L${institutionDetailsRow + 4}`).value =
					institutionEmail;
				ws.getCell(`L${institutionDetailsRow + 4}`).font = {
					size: 12,
				};

				ws.getCell(`L${institutionDetailsRow + 6}`).value = date;
				ws.getCell(`L${institutionDetailsRow + 6}`).font = {
					size: 12,
					bold: true,
				};

				ws.getCell(`L${institutionDetailsRow + 7}`).value = terms;
				ws.getCell(`L${institutionDetailsRow + 7}`).font = {
					size: 12,
					bold: true,
				};

				// Set column widths
				ws.getColumn("A").width = 5;
				ws.getColumn("B").width = 30;
				ws.getColumn("C").width = 20;
				ws.getColumn("D").width = 5;
				ws.getColumn("E").width = 30;
				ws.getColumn("F").width = 20;

				// Title
				const titleRow = institutionDetailsRow + 9;
				const titleCell = ws.getCell(`B${titleRow}`);
				titleCell.value = "NOTE TO THE BALANCE SHEET";
				titleCell.font = { bold: true, size: 16 };
				titleCell.alignment = { horizontal: "center" };
				ws.mergeCells(`B${titleRow}:F${titleRow}`);

				// Headers
				const headerRow = titleRow + 2;
				const headerStyle = { bold: true, size: 12 };

				// Assets header
				const assetsHeaderCell = ws.getCell(`B${headerRow}`);
				assetsHeaderCell.value = "ASSETS";
				assetsHeaderCell.font = headerStyle;
				assetsHeaderCell.alignment = { horizontal: "center" };
				ws.mergeCells(`B${headerRow}:C${headerRow}`);

				// Liabilities header
				const liabilitiesHeaderCell = ws.getCell(`E${headerRow}`);
				liabilitiesHeaderCell.value = "LIABILITIES + CAPITAL";
				liabilitiesHeaderCell.font = headerStyle;
				liabilitiesHeaderCell.alignment = { horizontal: "center" };
				ws.mergeCells(`E${headerRow}:F${headerRow}`);

				// Sub-headers
				const subHeaderRow = headerRow + 1;
				// Assets sub-headers
				ws.getCell(`B${subHeaderRow}`).value = "Name";
				ws.getCell(`B${subHeaderRow}`).font = headerStyle;
				ws.getCell(`C${subHeaderRow}`).value = "Amount (" + (this.institution.currency_code || "") + ")";
				ws.getCell(`C${subHeaderRow}`).font = headerStyle;

				// Liabilities sub-headers
				ws.getCell(`E${subHeaderRow}`).value = "Name";
				ws.getCell(`E${subHeaderRow}`).font = headerStyle;
				ws.getCell(`F${subHeaderRow}`).value = "Amount (" + (this.institution.currency_code || "") + ")";
				ws.getCell(`F${subHeaderRow}`).font = headerStyle;

				// --- NEW: Use independent row pointers for assets and liabilities ---
				let leftRow = subHeaderRow + 1;   // for assets (B/C)
				let rightRow = subHeaderRow + 1;  // for liabilities (E/F)

				const mainItemStyle = { bold: true };

				// Fill assets (left column)
				if (Array.isArray(this.assets_items)) {
					this.assets_items.forEach(assetItem => {
						// main head
						ws.getCell(`B${leftRow}`).value = assetItem.display_name;
						ws.getCell(`B${leftRow}`).font = mainItemStyle;
						const assetBalance = assetItem.transactions?.[0]?.balance ?? 0;
						ws.getCell(`C${leftRow}`).value = Number(assetBalance);
						ws.getCell(`C${leftRow}`).font = mainItemStyle;
						ws.getCell(`C${leftRow}`).numFmt = '#,##0.00';
						leftRow++;

						// subheads
						if (assetItem.subheads && assetItem.subheads.length) {
							assetItem.subheads.forEach(subhead => {
								ws.getCell(`B${leftRow}`).value = "  " + subhead.name;
								ws.getCell(`C${leftRow}`).value = Number(subhead.total ?? 0);
								ws.getCell(`C${leftRow}`).numFmt = '#,##0.00';
								leftRow++;
							});
						}
					});
				}

				// --- ADD: write provisions and Net Asset under the assets column ---
				if (Array.isArray(this.provisions) && this.provisions.length) {
					// Title for provisions
					ws.getCell(`B${leftRow}`).font = { bold: true };
					leftRow++;

					this.provisions.forEach(provision => {
						// Provision main line (display_name)
						ws.getCell(`B${leftRow}`).value = provision.display_name;
						ws.getCell(`B${leftRow}`).font = { bold: true };
						const provBalance = provision.transactions?.[0]?.balance ?? 0;
						ws.getCell(`C${leftRow}`).value = Number(provBalance);
						ws.getCell(`C${leftRow}`).numFmt = '#,##0.00';
						leftRow++;

						// Provision subheads (if any)
						if (provision.subheads && provision.subheads.length) {
							provision.subheads.forEach(sub => {
								ws.getCell(`B${leftRow}`).value = "  " + sub.name;
								ws.getCell(`C${leftRow}`).value = Number(sub.total ?? 0);
								ws.getCell(`C${leftRow}`).numFmt = '#,##0.00';
								leftRow++;
							});
						}
					});

					// Optional spacer line
					leftRow++;
				}

				// Compute adjusted total assets (matches your template logic)
				const adjustedAssets = Number(this.grant_total_assets ?? 0) - (Number(this.accumulated_dep ?? 0) - Number(this.grant_total_provisions ?? 0));

				// // Write adjusted total assets (as in your UI "Total Assest" row)
				// ws.getCell(`B${leftRow}`).value = "Total Assets (Adjusted)";
				// ws.getCell(`B${leftRow}`).font = { bold: true };
				// ws.getCell(`C${leftRow}`).value = adjustedAssets;
				// ws.getCell(`C${leftRow}`).numFmt = '#,##0.00';
				// ws.getCell(`C${leftRow}`).font = { bold: true };
				// leftRow++;

				// // Write Net Asset (as in your UI "Net Asset" row)
				// ws.getCell(`B${leftRow}`).value = "Net Asset";
				// ws.getCell(`B${leftRow}`).font = { bold: true };
				// ws.getCell(`C${leftRow}`).value = Number(this.grant_total_assets ?? 0);
				// ws.getCell(`C${leftRow}`).numFmt = '#,##0.00';
				// ws.getCell(`C${leftRow}`).font = { bold: true };
				// leftRow++;

				// Fill liabilities (right column)
				if (Array.isArray(this.liability_items)) {
					this.liability_items.forEach(liabilityItem => {
						// main head
						ws.getCell(`E${rightRow}`).value = liabilityItem.display_name;
						ws.getCell(`E${rightRow}`).font = mainItemStyle;
						const liabBalance = liabilityItem.transactions?.[0]?.balance ?? 0;
						ws.getCell(`F${rightRow}`).value = Number(liabBalance);
						ws.getCell(`F${rightRow}`).font = mainItemStyle;
						ws.getCell(`F${rightRow}`).numFmt = '#,##0.00';
						rightRow++;

						// subheads
						if (liabilityItem.subheads && liabilityItem.subheads.length) {
							liabilityItem.subheads.forEach(subhead => {
								ws.getCell(`E${rightRow}`).value = "  " + subhead.name;
								ws.getCell(`F${rightRow}`).value = Number(subhead.total ?? 0);
								ws.getCell(`F${rightRow}`).numFmt = '#,##0.00';
								rightRow++;
							});
						}
					});
				}

				// --- NEW: Align totals rows for both sides ---
				const totalsRow = Math.max(leftRow, rightRow) + 2;

				// Row 0: Total Assets (Adjusted)  | Total Liabilities
				ws.getCell(`B${totalsRow}`).value = "Total Assets";
				ws.getCell(`B${totalsRow}`).font = mainItemStyle;
				ws.getCell(`C${totalsRow}`).value = Number(this.grant_total_assets ?? 0);
				ws.getCell(`C${totalsRow}`).numFmt = "#,##0.00";
				ws.getCell(`C${totalsRow}`).font = mainItemStyle;

				ws.getCell(`E${totalsRow}`).value = "Total Liabilities";
				ws.getCell(`E${totalsRow}`).font = mainItemStyle;
				ws.getCell(`F${totalsRow}`).value = Number(this.grant_total_liabilities ?? 0);
				ws.getCell(`F${totalsRow}`).numFmt = "#,##0.00";
				ws.getCell(`F${totalsRow}`).font = mainItemStyle;

				// Row 1: Net Asset | Total Surplus
				const row1 = totalsRow + 2;
				ws.getCell(`B${row1}`).value = "Net Asset";
				ws.getCell(`B${row1}`).font = mainItemStyle;
				ws.getCell(`C${row1}`).value = Number(this.net_assets ?? 0);
				ws.getCell(`C${row1}`).numFmt = "#,##0.00";
				ws.getCell(`C${row1}`).font = mainItemStyle;

				// const row2 = totalsRow + 2;
				// ws.getCell(`B${row2}`).value = "Net Asset";
				// ws.getCell(`B${row2}`).font = mainItemStyle;
				// ws.getCell(`C${row2}`).value = Number(this.grant_total_assets ?? 0);
				// ws.getCell(`C${row2}`).numFmt = "#,##0.00";
				// ws.getCell(`C${row2}`).font = mainItemStyle;

				const row3 = totalsRow + 1;
				ws.getCell(`E${row3}`).value = "Total Surplus";
				ws.getCell(`E${row3}`).font = mainItemStyle;
				ws.getCell(`F${row3}`).value = Number(this.grant_total_surpluses ?? 0);
				ws.getCell(`F${row3}`).numFmt = "#,##0.00";
				ws.getCell(`F${row3}`).font = mainItemStyle;

				// Row 2: (optional spacer) and Liabilities + Surplus
				const row4 = totalsRow + 2;
				ws.getCell(`E${row4}`).value = "Total Liabilities + Surplus";
				ws.getCell(`E${row4}`).font = mainItemStyle;
				ws.getCell(`F${row4}`).value = Number(this.liabilities_plus_surplus ?? 0);
				ws.getCell(`F${row4}`).numFmt = "#,##0.00";
				ws.getCell(`F${row4}`).font = mainItemStyle;

				// Ratio section
				const ratioRow = row4 + 3;
				ws.getCell(`B${ratioRow}`).value = "Information on Ratio";
				ws.getCell(`B${ratioRow}`).font = { bold: true, size: 14 };
				ws.mergeCells(`B${ratioRow}:F${ratioRow}`);
				ws.getCell(`B${ratioRow}`).alignment = { horizontal: "center" };

				const ratioDetailsRow = ratioRow + 1;
				ws.getCell(`B${ratioDetailsRow}`).value = "Liquidity Reserve";
				ws.getCell(`C${ratioDetailsRow}`).value = (Number(this.liquidity_res) || 0).toFixed(2) + " %";

				ws.getCell(`D${ratioDetailsRow}`).value = "Return on Asset";
				ws.getCell(`E${ratioDetailsRow}`).value = (Number(this.return_on_assets) || 0).toFixed(2) + " %";

				const ratioDetailsRow2 = ratioDetailsRow + 1;
				ws.getCell(`B${ratioDetailsRow2}`).value = "Capital Adequacy";
				ws.getCell(`C${ratioDetailsRow2}`).value = (Number(this.capital_adequacy) || 0).toFixed(2) + " %";

				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});

				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = `Note_To_Balance_Sheet_${this.form.start_date}_to_${this.form.end_date}.xlsx`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
	},
};
</script>
